export default __webpack_public_path__ + "static/media/pencil-black.39f05284.svg";